/* eslint-disable @typescript-eslint/no-unused-expressions */
import { progressApi } from "utilities/Axios";

export const getUserTickets = async () => {
  return progressApi.get("/ticket/getmyticket");
};

export const getTickets = async () => {
  return progressApi.get("/ticket/getallticket");
};

export const createTicket = async (data: any) => {
  return progressApi.post("/ticket/createticket", data);
};

export const closeTicket = (data: any) => {
  return progressApi.post("/ticket/closeticket" + `?id=${data}`);
};

export const rejectTicket = (data: any) => {
  return progressApi.post("/ticket/rejectticket" + `?id=${data}`);
};
export const deleteTicket = (data: any) => {
  return progressApi.post("/ticket/deleteticket" + `?id=${data}`);
};
